export default __webpack_public_path__ + "static/8-ddff49c3ba87808a8959ff2d1ab24291.jpg";